import { Injectable } from '@angular/core';
import {AbstractDatabaseService} from "../../tandem-core/services/abstract-database.service";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {FinancialPositionChartMetadata} from "../models/financial-position-chart-metadata";
import {Timestamp} from "firebase/firestore";

@Injectable({
  providedIn: 'root'
})
export class FinancialPositionChartMetadataService extends AbstractDatabaseService<FinancialPositionChartMetadata> {

  constructor(protected override afs: AngularFirestore) {
    super('financialPositionChartMetadata', afs);
  }

  generateSampleChartData(userId: string): FinancialPositionChartMetadata {

    return {
      dateCreated: Timestamp.now(), dateModified: Timestamp.now(),
      userId: '4xAYvEll38Rqbf88On5SPnzovpf1',
      charts: [
        {
          financialPositionId: 'gAbie8zBBcVVNoL5uWOp',
          netWorth: 478665.78000000014,
          totalAssets: 1080152.1,
          totalLiabilities: 601486.32,
          positionDate: Timestamp.fromDate(new Date('2025-05-01'))
        },
        {
          financialPositionId: 'mP8i0HKxt2erezc5tntO',
          netWorth: 470000.5,
          totalAssets: 1404078,
          totalLiabilities: 934077.5,
          positionDate: Timestamp.fromDate(new Date('2025-06-01'))
        },
        {
          financialPositionId: 'e0MtglmfCGgQUBouzL7Y',
          netWorth: 487779.51000000024,
          totalAssets: 1490624.7000000002,
          totalLiabilities: 1002845.19,
          positionDate: Timestamp.fromDate(new Date('2025-07-01'))
        },
        {
          financialPositionId: 'c0d1ODgGqXA5hXYzz658',
          netWorth: 554258.3099999998,
          totalAssets: 1188760.96,
          totalLiabilities: 634502.6500000001,
          positionDate: Timestamp.fromDate(new Date('2025-08-01'))
        },
        {
          financialPositionId: '89v2nQeNYySxZ8w2jIQg',
          netWorth: 554258.3099999998,
          totalAssets: 1188760.96,
          totalLiabilities: 634502.6500000001,
          positionDate: Timestamp.fromDate(new Date('2025-05-27'))
        }
      ]
    }

    //
    //
    // let dates: Date[] = [];
    // let currentDate = new Date();
    //
    // for (let i = 0; i < 6; i++) {
    //   // Add a copy of the current date to the array
    //   dates.push(new Date(currentDate.getTime()));
    //
    //   // Subtract one month from the current date
    //   currentDate.setMonth(currentDate.getMonth() - 1);
    // }
    // return {
    //   userId: userId,
    //   dateCreated: Timestamp.now(),
    //   dateModified: Timestamp.now(),
    //   charts: [
    //     {
    //       financialPositionId: '1',
    //       positionDate: Timestamp.fromDate(dates[5]),
    //       netWorth: 39660.59,
    //       totalAssets: 112514.98,
    //       totalLiabilities: 72854.39,
    //     },
    //     {
    //       financialPositionId: '2',
    //       positionDate: Timestamp.fromDate(dates[4]),
    //       netWorth: 41490.09,
    //       totalAssets: 113148.26,
    //       totalLiabilities: 71658.17,
    //     },
    //     {
    //       financialPositionId: '1',
    //       positionDate: Timestamp.fromDate(dates[3]),
    //       netWorth: 48341.03,
    //       totalAssets: 117625.18,
    //       totalLiabilities: 69284.15,
    //     },
    //     {
    //       financialPositionId: '1',
    //       positionDate: Timestamp.fromDate(dates[2]),
    //       netWorth: 76640.00,
    //       totalAssets: 185294.28,
    //       totalLiabilities: 108654.28,
    //     },
    //     {
    //       financialPositionId: '1',
    //       positionDate: Timestamp.fromDate(dates[1]),
    //       netWorth: 72043.88,
    //       totalAssets: 181784.26,
    //       totalLiabilities: 109740.38,
    //     },
    //     {
    //       financialPositionId: '1',
    //       positionDate: Timestamp.fromDate(dates[0]),
    //       netWorth: 73501.67,
    //       totalAssets: 182647.92,
    //       totalLiabilities: 109146.25,
    //     },
    //   ]
    // }
  }
}
